<template>
  <View
    gap="md"
    padding-inline="md"
    align="center"
    justify="space-between"
    class="trigger"
    :class="{ selected: selectedShowingAgent }"
  >
    <View gap="sm" align="center">
      <Avatar v-if="selectedShowingAgent" :userName="label" :showSingleLetter="true" class="avatar" />
      <ShowingAgentPickerAvatarPlaceholder icon="user-03" v-else />
      <Text variant="body-medium">{{ label }}</Text>
    </View>
    <LoadingIndicator v-if="isLoading" />
    <Icon v-else name="chevron-down" class="trigger-icon" />
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Avatar, Icon, LoadingIndicator, Text, View } from '@tallo/design-system';
import { getFullName } from '@tallo/utility';

import { ShowingAgentDto } from '../interfaces/showing-agent.dto';
import ShowingAgentPickerAvatarPlaceholder from './showing-agent-picker-avatar-placeholder.vue';

const props = defineProps<{
  isLoading: boolean;
  selectedShowingAgent: ShowingAgentDto | undefined;
}>();

const label = computed(() =>
  props.selectedShowingAgent ? getFullName(props.selectedShowingAgent) : 'Choose your showing agent',
);
</script>

<style scoped lang="scss">
.avatar {
  --avatar-size: 1.5rem;
}

.trigger-icon {
  color: var(--t-text-color-tertiary);
}

.trigger {
  height: 3rem;
  background-color: var(--t-color-neutral-white);
  border: 1px solid var(--t-color-neutral-400);
  border-radius: var(--t-border-radius-sm);
  cursor: pointer;

  color: var(--t-color-neutral-500);

  transition: border-color 150ms ease-in-out;

  &.selected {
    color: var(--t-text-color-primary);
  }

  &:hover {
    border-color: var(--t-text-color-tertiary);
  }
}
</style>
